import { useTranslation } from 'react-i18next';

import { ReactComponent as User } from 'assets/icons/User.svg';
import useMxCookies from 'modules/Authentication/hooks/useMxCookies';
import useCreateNewRoomDataContext from 'modules/CreateNewRoomModal/CreateNewRoomDataProvider/useCreateNewRoomDataContext';

import AddedParticipant from './AddedParticipant';

interface AddedParticipantsListProps {
  onParticipantRemove: (participantEmail: string) => void;
}

const AddedParticipantsList = ({ onParticipantRemove }: AddedParticipantsListProps) => {
  const { t } = useTranslation();
  const { mxDisplayName, mxLoggedIn } = useMxCookies();
  const {
    roomForm: { watch },
  } = useCreateNewRoomDataContext();

  const participantsWatch = watch('participants');
  const ownerText = `${mxDisplayName || t('owner')} (${t('you').toLowerCase()})`;

  return (
    <>
      <div className="flex flex-col gap-2 max-h-[232px] overflow-y-auto pr-4">
        {mxLoggedIn && <AddedParticipant icon={User}>{ownerText}</AddedParticipant>}
        {participantsWatch.map((participantEmail) => (
          <AddedParticipant key={participantEmail} onRemove={onParticipantRemove}>
            {participantEmail}
          </AddedParticipant>
        ))}
      </div>
    </>
  );
};

export default AddedParticipantsList;
